import React from "react";
import { isWidthUp, makeStyles, withWidth } from "@material-ui/core";
import { useEffectAsync } from "./reactHelper";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flexGrow: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
    },
  },
  drawerPaper: {
    position: "relative",
    [theme.breakpoints.up("sm")]: {
      width: 350,
    },
    [theme.breakpoints.down("xs")]: {
      height: 250,
    },
  },
  mapContainer: {
    flexGrow: 1,
  },
}));

const MainPage = (props) => {
  const classes = useStyles();
  const queryString = props.location && props.location.search;

  const urlParams = new URLSearchParams(queryString);
  const [infoData, setInfoData] = React.useState({});

  const data = urlParams.get("id");
  useEffectAsync(async () => {
    const response = await fetch(
      `/api/vendors/getVendorPublicInfo/?app=${data}`
    );
    if (response.ok) {
      const body = await response.json();
      setInfoData(body);
      // dispatch(sessionActions.updateServer(await response.json()));
    }
  }, []);

  return (
    <div className={classes.root}>
      <h2>Welcome to {infoData.name}</h2>
      <p>
        These terms and conditions outline the rules and regulations for the use
        of {infoData.name} Services.
      </p>{" "}
      <br />
      <p>
        By accessing this website we assume you accept these terms and
        conditions in full. Do not continue to use {infoData.name} Services if
        you do not accept all of the terms and conditions stated on this page.
      </p>
      <p>
        The following terminology applies to these Terms and Conditions, Privacy
        Statement and Disclaimer Notice and any or all Agreements: 'Client',
        'You' and 'Your' refers to you, the person accessing this website and
        accepting the Company’s terms and conditions. 'The Company',
        'Ourselves', 'We', 'Our' and 'Us', refers to our Company. 'Party',
        'Parties', or 'Us', refers to both the Client and ourselves, or either
        the Client or ourselves. All terms refer to the offer, acceptance and
        consideration of payment necessary to undertake the process of our
        assistance to the Client in the most appropriate manner, whether by
        formal meetings of a fixed duration, or any other means, for the express
        purpose of meeting the Client’s needs in respect of provision of the
        Company’s stated services/products, in accordance with and subject to,
        prevailing law of . Any use of the above terminology or other words in
        the singular, plural, capitalisation and/or he/she or they, are taken as
        interchangeable and therefore as referring to same.
      </p>
      <h2>Cookies</h2>
      <p>
        We employ the use of cookies. By using {infoData.name} our services you
        consent to the use of cookies in accordance with {infoData.name}
        privacy policy.
      </p>
      <p>
        Most of the modern day interactive web sites use cookies to enable us to
        retrieve user details for each visit. Cookies are used in some areas of
        our site to enable the functionality of this area and ease of use for
        those people visiting. Some of our affiliate / advertising partners may
        also use cookies.
      </p>
      <h2>License</h2>
      <p>
        Unless otherwise stated, {infoData.name} and/or it’s licensors own the
        intellectual property rights for all material on {infoData.name}. All
        intellectual property rights are reserved. You may view and/or print
        pages from  { infoData.website ? `http://${infoData.website}` : infoData.name} for your own personal use subject
        to restrictions set in these terms and conditions.
      </p>
      <p>You must not:</p>
      <ol>
        <li>Republish material from { infoData.website ? `http://${infoData.website}` : infoData.name}</li>
        <li>
          Sell, rent or sub-license material from { infoData.website ? `http://${infoData.website}` : infoData.name}
        </li>
        <li>
          Reproduce, duplicate or copy material from { infoData.website ? `http://${infoData.website}` : infoData.name}
        </li>
      </ol>
      <p>
        Redistribute content from {infoData.name} (unless content is specifically
        made for redistribution).
      </p>
      <h2>Hyperlinking to our Content</h2>
      <ol>
        <li>
          The following organizations may link to our Web site without prior
          written approval:
          <ol>
            <li>Government agencies;</li>
            <li>Search engines;</li>
            <li>News organizations;</li>
            <li>
              Online directory distributors when they list us in the directory
              may link to our Web site in the same manner as they hyperlink to
              the Web sites of other listed businesses; and
            </li>
            <li>
              Systemwide Accredited Businesses except soliciting non-profit
              organizations, charity shopping malls, and charity fundraising
              groups which may not hyperlink to our Web site.
            </li>
          </ol>
        </li>
      </ol>
      <ol start="2">
        <li>
          These organizations may link to our home page, to publications or to
          other Web site information so long as the link: (a) is not in any way
          misleading; (b) does not falsely imply sponsorship, endorsement or
          approval of the linking party and its products or services; and (c)
          fits within the context of the linking party's site.
        </li>
        <li>
          We may consider and approve in our sole discretion other link requests
          from the following types of organizations:
          <ol>
            <li>
              commonly-known consumer and/or business information sources such
              as Chambers of Commerce, American Automobile Association, AARP and
              Consumers Union;
            </li>
            <li>dot.com community sites;</li>
            <li>
              associations or other groups representing charities, including
              charity giving sites,
            </li>
            <li>online directory distributors;</li>
            <li>internet portals;</li>
            <li>
              accounting, law and consulting firms whose primary clients are
              businesses; and
            </li>
            <li>educational institutions and trade associations.</li>
          </ol>
        </li>
      </ol>
      <p>
        We will approve link requests from these organizations if we determine
        that: (a) the link would not reflect unfavorably on us or our accredited
        businesses (for example, trade associations or other organizations
        representing inherently suspect types of business, such as work-at-home
        opportunities, shall not be allowed to link); (b)the organization does
        not have an unsatisfactory record with us; (c) the benefit to us from
        the visibility associated with the hyperlink outweighs the absence of
        and (d) where the link is in the context of general resource information
        or is otherwise consistent with editorial content in a newsletter or
        similar product furthering the mission of the organization.
      </p>
      <p>
        These organizations may link to our home page, to publications or to
        other Web site information so long as the link: (a) is not in any way
        misleading; (b) does not falsely imply sponsorship, endorsement or
        approval of the linking party and it products or services; and (c) fits
        within the context of the linking party's site.
      </p>
      <p>
        If you are among the organizations listed in paragraph 2 above and are
        interested in linking to our website, you must notify us by sending an
        e-mail to{" "}
        <a
          href="mailto:{infoData.email}"
          title="send an email to {infoData.email}"
        >
          {infoData.email}
        </a>
        . Please include your name, your organization name, contact information
        (such as a phone number and/or e-mail address) as well as the URL of
        your site, a list of any URLs from which you intend to link to our Web
        site, and a list of the URL(s) on our site to which you would like to
        link. Allow 2-3 weeks for a response.
      </p>
      <p>Approved organizations may hyperlink to our Web site as follows:</p>
      <ol>
        <li>By use of our corporate name; or</li>
        <li>
          By use of the uniform resource locator (Web address) being linked to;
          or
        </li>
        <li>
          By use of any other description of our Web site or material being
          linked to that makes sense within the context and format of content on
          the linking party's site.
        </li>
      </ol>
      <p>
        No use of {infoData.name}’s logo or other artwork will be allowed for
        linking absent a trademark license agreement.
      </p>
      <h2>Iframes</h2>
      <p>
        Without prior approval and express written permission, you may not
        create frames around our Web pages or use other techniques that alter in
        any way the visual presentation or appearance of our Web site.
      </p>
      <h2>Reservation of Rights</h2>
      <p>
        We reserve the right at any time and in its sole discretion to request
        that you remove all links or any particular link to our Web site. You
        agree to immediately remove all links to our Web site upon such request.
        We also reserve the right to amend these terms and conditions and its
        linking policy at any time. By continuing to link to our Web site, you
        agree to be bound to and abide by these linking terms and conditions.
      </p>
      <h2>Removal of links from our website</h2>
      <p>
        If you find any link on our Web site or any linked web site
        objectionable for any reason, you may contact us about this. We will
        consider requests to remove links but will have no obligation to do so
        or to respond directly to you.
      </p>
      <p>
        Whilst we endeavour to ensure that the information on this website is
        correct, we do not warrant its completeness or accuracy; nor do we
        commit to ensuring that the website remains available or that the
        material on the website is kept up to date.
      </p>
      <h2>Content Liability</h2>
      <p>
        We shall have no responsibility or liability for any content appearing
        on your Web site. You agree to indemnify and defend us against all
        claims arising out of or based upon your Website. No link(s) may appear
        on any page on your Web site or within any context containing content or
        materials that may be interpreted as libelous, obscene or criminal, or
        which infringes, otherwise violates, or advocates the infringement or
        other violation of, any third party rights.
      </p>
      <h2>Disclaimer</h2>
      <p>
        To the maximum extent permitted by applicable law, we exclude all
        representations, warranties and conditions relating to our website and
        the use of this website (including, without limitation, any warranties
        implied by law in respect of satisfactory quality, fitness for purpose
        and/or the use of reasonable care and skill). Nothing in this disclaimer
        will:
      </p>
      <ol>
        <li>
          limit or exclude our or your liability for death or personal injury
          resulting from negligence;
        </li>
        <li>
          limit or exclude our or your liability for fraud or fraudulent
          misrepresentation;
        </li>
        <li>
          limit any of our or your liabilities in any way that is not permitted
          under applicable law; or
        </li>
        <li>
          exclude any of our or your liabilities that may not be excluded under
          applicable law.
        </li>
      </ol>
      <p>
        The limitations and exclusions of liability set out in this Section and
        elsewhere in this disclaimer: (a) are subject to the preceding
        paragraph; and (b) govern all liabilities arising under the disclaimer
        or in relation to the subject matter of this disclaimer, including
        liabilities arising in contract, in tort (including negligence) and for
        breach of statutory duty.
      </p>
      <p>
        To the extent that the website and the information and services on the
        website are provided free of charge, we will not be liable for any loss
        or damage of any nature.
      </p>
      <p>By using our terms and conditions you also follow these guidelines:</p>
      <p>1. The customers using our services will be solely responsible for the login ids/passwords and store them in a secure
          way.
          <br />2. We only save the GPS pings ( For the approx max 3 months time period or can be less than it,
          if it is mutually decided between us and the person using our services), if and only if the device sends the pings
          to our server.
          <br />3. We only save devices sending the location pings log for maximum 1 day only.
          <br />4. Any Installer/GPS Service provider who had installed their own GPS Device or any related equipments (like SIM Card) at your
          location/vehicle/device and who is using our cloud services only then he/she will be solely responsible to handle
          such customers/agencies etc. In these cases Any Loss occurred to the customers/agencies will be borne by them only. The Services also will be provided by them only. We are not responsible if they are not providing the committed services to you.
          <br />5. In case of any unlawful activity or any illegal disputes, jurisdictions will be handled by Gurugram, Haryana,
          India District Court only.
          <br />6. We do not share your data with any third party without your permission but there is some exclusions like if
          any Government Agency/Organisation/Authority/Intelligence Agencies/Tax Department or Tax Agencies/Search Warrant
          ordered by any Court/ or top level Government Officials (e.g. Commissioner/Director etc.) of any country in which we
          are providing our services asks for data of any user/device/transactions/Personally Identifiable Information/Numbers
          or any data saved on our systems then we are liable to provide them the data with or without your knowledge or
          permission. In this type of cases we will not be accountable for any loss occurred to you due to these activities.
          You will solely be liable in any data infringement, if you have done any. And you are also liable of maintaining the
          correct information of your account and related data stored on our systems. You will be solely responsible for any
          action taken on your data by using your account credentials. Our resellers are also adhere to the same policy as our
          customers. And if any reseller doesn't follow this policy or breach then they will be solely responsible for any
          action done by them or any of their customers.
          <br />7. The end customer and their respective service provider is solely responsible for the correctness or any other recent changes of the data stored in our system as we don’t have any authentic way of confirming the end user’s identity or end user’s vehicles details. The service provider should be solely responsible for the KYC of its end consumers.
          <br />8. The GPS service provider is solely responsible for entering or maintaining the correct details like IMEI, SIM NUMBER, End user’s mail address, Name, Vehicle Model, Device Model, Vehicle’s registered numbers etc.
          <br />9. We won’t share any user’s username and password to anyone. We can’t decode your passwords. So if any account’s details raised by any government agencies described above then we can ask you to provide the relevant details to them or we can reset your account access for them. In extreme cases we can suspend your accounts and will be resumed only after the mutual consent. (but we try to minify their requirements at our end. As an ambiguous access can be responsible for the loss of any kind.). We can provide the data to the government agencies but the data provided is not authenticated in any way. So it is not a good practice to use it as a legal evidence because it can be tampered easily. Our company won’t be responsible for the tampering of data because we can’t restrict the end user or GPS service provider as it’s does not fall under the manageable conditions. But it’s your responsibility to overcome these type of enquiries at your end because we only have the data which is either presented by you or your assets. So you are at the best position to analyse and understand your data and can easily reply for such enquiries. We are also not responsible for the accuracy of your data. The GPS installer or service provider is the authorised person to do any changes in your accounts. So, we won’t be responsible for any loss occurred to you by their any action. If you share it to anyone then you will be liable for the losses occurred due to this action. We won’t be liable if there is any accident/mishaps happened due to any action taken by them using our app or web platform. We even won’t be liable to any theft of vehicles or goods into the vehicles by having access of live tracking of your assets. You are also liable to take care of your own safety. Our tracking system should be used as just for location tracking of your assets. If you are using our system for personal trackers then you should have a valid agreement with the person who is going to be tracked by our system.
          <br />10. Our system or network delay won’t be responsible for any loss, any penalty or delay in transit. Our tracking system is dependent on many factors like networks, Device power loss, Device damaged, Device not in working condition, GPRS connectivity, GPS device signal strength for network or GPS fix, Internet service providers, Jammers and no network zones etc. So, if any of these is causing problems or delay in data received on server or display delay on web panel or apps then we won’t be responsible for it also.
          <br />11. We won’t be responsible for any hardware failure or mechanical failure happened due to device installed into your vehicle. It’s your responsibility to check the authenticity of the person installing device or the service provider. As we are only a GPS tracking software provider. We won’t deals in hardware or hardware installations. You can’t relocate the device anywhere else unless you have taken the permission either from your service provider or the owner of the asset who is going to be tracked. I.e. you can’t change the owner of device until you have permissions. If you do so then you are the responsible person for any personal or any other kind of loss to you or to that person.
          <br />12. Device’s location can be incorrect due to many factors. We won’t be responsible if you’re receiving wrong location on web panel or our apps. Although we have tried our best to overcome most of the problems by software advancements.
          <br />13. We rely on third party tracking tools like Google Maps, OpenStreetMaps, Geo-addresses, so we won’t be liable for any incorrect details displayed by them. We are also not responsible for any incorrect address displayed on maps because there are Billions of addresses and there can be any data discrepancy in that data. Although we will try to rectify those details in a timely manner. There won’t be any deadline for that.
          <br />14. We can change the display maps anytime with or without the user’s consent. We are not in agreement with any user or GPS service provider regarding maps. As we are charging you accordingly their current rate plans. Although we try to give our users the best experience in terms of maps.
          <br />15. We can change the pricing anytime as we are fully authorised authority to any change in prices. Any old agreement regarding prices will be nullified after new pricing. We can also increase/decrease the prices of your currently subscribed plans as our system is dependent on many third party services. If you are not willing to pay the upgrade in prices then you can willingly discontinue our services. If you are subscribed to our yearly plan then this won’t mean that we can’t change it. We can change or ask you to pay for the services which undergoes any plan changes. Currently we are charging you only for saving your device’s data only.
          <br />16. We won’t be responsible for any data loss event occurred either by you, GPS service provider/installer, or from our Cloud service provider or any man made mistakes. So, we suggest you to save a backup of your data in terms of reports (xslx or pdf), or in any other forms on regular basis.
          <br />17. You will be solely responsible for any revenue loss or any kind of loss occurred to other persons/authorities done by you in any manner. You won’t use our system to befool anyone in terms of money, revenue, or any mean terms.
          <br />18. We don’t take any incremental backups of your any type of data as per our current pricing. We can change this policy in future if do have higher pricing plans. So kindly keep yourself updated by reviewing this section over the time.
          <br />19. You will be solely responsible in any case where command is sent by any person to your device in these cases device behave according to command and can stop working and will also affect vehicle's functioning (eg. In case your vehicle's status is running and someone send device stop command then your vehicle will stop. So please check or ask your GPS Provider that She/he installs a good quality device so that they can detect the situation upto some extent OR do not stop working immediately instead they detect the situation.). We recommend not to send commands in an area where network connectivity is not good.
          </p>
      <h2></h2>
      <p></p>
      <h2>Credit & Contact Information</h2>
      <p>
        This Terms and conditions page was created at{" "}
        <a href="https://termsandconditionstemplate.com">
          termsandconditionstemplate.com
        </a>{" "}
        generator. If you have any queries regarding any of our terms, please
        contact us.
      </p>
      <p>
        The credit for the logo goes to{" "}
        <a href="https://www.flaticon.com/authors/freepik">Freepik</a> from{" "}
        <a href="https://termsandconditionstemplate.com">www.flaticon.com</a>
      </p>
    </div>
  );
};

export default withWidth()(MainPage);
